import React, { useState, useEffect } from "react"
import {
  Container,
  StepperContainer,
  StepperHeader,
  StepperHeaderElement,
  Alert,
  Button,
  Row,
  Col
} from 'design-react-kit';

import SibaTabellaVeicoliAttivi from "../components/consultazione/SibaTabellaVeicoliAttivi";
import SibaMostraSituazionePagamenti from "../components/consultazione/SibaMostraSituazionePagamenti";
import * as Constants from '../utils/constants'
import SibaBreadcrumb from '../components/common/SibaBreadcrumb'
import SibaMostraCalcolo from "../components/consultazione/SibaMostraCalcolo";
import SibaPrenotaPagamento from "../components/common/pagamento/SibaPrenotaPagamento";
import ErrorBoundary from "../components/common/ErrorBoundary";
import SibaMostraDettagliVeicolo from "../components/consultazione/SibaMostraDettagliVeicolo";
import SibaMostraDettagliPagamento from "../components/consultazione/SibaMostraDettagliPagamento";
import { authenticate } from '../services/endpoints'
import { isUndefined, isPresentAuthenticatedUser } from "../utils/utilities";

export const SibaConsultazioneVeicoliAttivi = ({ authMode }) => {

  // User data
  const [veicolo, setVeicolo] = useState({});
  const [schedaPagamento, setSchedaPagamento] = useState({});
  const [calcolo, setCalcolo] = useState({});
  const [email, setEmail] = useState('');

  // Navigation
  const [currentStep, setCurrentStep] = useState(Constants.STEP_1);
  const [choiceDettagli, setChoiceDettagli] = useState('');
  const [choicePagamento, setChoicePagamento] = useState('');

  useEffect(() => {
    const loadCurrentUser = async () => {
      let user = await authenticate();
      console.log('App.js user=', user)
      if (user !== undefined) {
        if (!isUndefined(user.user)) {
          console.log('App.js user id=', user.user)
          sessionStorage.setItem(Constants.USER_IN_SESSION, user.user)
        };
      }
    }

    if (!isPresentAuthenticatedUser() && (authMode === Constants.AUTH_MODE_PROTECTED)) {
      loadCurrentUser();
    }
  }, [])

  const handleBack = () => { if (currentStep > Constants.STEP_1) { setCurrentStep(currentStep - 1) } };
  const handleNext = () => { setCurrentStep(currentStep + 1) };
  const handleVeicoloSelezionato = (data) => { setVeicolo(data.veicolo); setChoiceDettagli(data.choice); handleNext() };
  const handleRichiestaPagamento = (data) => { setSchedaPagamento(data.schedaPagamento); setChoicePagamento(data.choice); handleNext() };
  const handleCalcoloLoaded = (data) => { setCalcolo(data) }; // currentStep: 4
  const handleEmailChange = (_email) => { setEmail(_email.toLowerCase()) };

  const showStep1 = () => {
    return (
      <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
        <SibaTabellaVeicoliAttivi
          cf={sessionStorage.getItem(Constants.USER_IN_SESSION)}
          handleChoice={handleVeicoloSelezionato} />
      </ErrorBoundary>
    )
  }

  const showStep2 = () => {
    console.log('choiceDettagli=', choiceDettagli)
    switch (choiceDettagli) {
      case Constants.CONS_CHOICE_DETTAGLI_PAGAMENTI:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraSituazionePagamenti
              _veicolo={veicolo}
              _handleSubmit={handleRichiestaPagamento}
              _handleBack={handleBack} />
          </ErrorBoundary>
        )
      case Constants.CONS_CHOICE_DETTAGLI_VEICOLO:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraDettagliVeicolo
              veicolo={veicolo}
              handleBack={handleBack} />
          </ErrorBoundary>
        )
      default:
        return showAlertForStep(currentStep);
    }
  }

  const showStep3 = () => {
    console.log('choicePagamento=', choicePagamento)
    switch (choicePagamento) {
      case Constants.CONS_CHOICE_PAGAMENTO_CALCOLO:
        return (
          <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
            <SibaMostraCalcolo
              veicolo={veicolo}
              situazionePagamento={schedaPagamento}
              handleDataLoaded={handleCalcoloLoaded}
              handleNext={handleNext}
            />
          </ErrorBoundary>
        )
      case Constants.CONS_CHOICE_PAGAMENTO_DETTAGLI:
        return (
          < ErrorBoundary FallbackComponent={OurFallbackComponentTODO} >
            <SibaMostraDettagliPagamento
              schedaPagamento={schedaPagamento}
              veicolo={veicolo}
              handleSubmit={handleBack}
            />
          </ErrorBoundary >
        )
      default:
        return showAlertForStep(currentStep);
    }
  }

  const showStep4 = () => {
    console.log("MM ", veicolo)
    console.log("MM ", calcolo)
    return (
      <ErrorBoundary FallbackComponent={OurFallbackComponentTODO}>
        <SibaPrenotaPagamento
          _tipoVeicolo={veicolo.tipoVeicolo}
          _targa={veicolo.targa}
         _codiceFiscale={calcolo.identificativoFiscale}
          _calcolo={calcolo}
          _email={email}
          _handleEmailChange={handleEmailChange}
          _authMode={authMode}
        />
      </ErrorBoundary>
    )
  }

  const getStepContent = (step) => {
    console.log("Current step= #" + currentStep)
    switch (step) {
      case Constants.STEP_1: return showStep1();
      case Constants.STEP_2: return showStep2();
      case Constants.STEP_3: return showStep3();
      case Constants.STEP_4: return showStep4();
      default: return showAlertForStep(step);
    }
  }

  const showAlertForStep = (step) => {
    return (
      <Container className="px-2 my-2" id="calcolaPaga" tag="section">
        <Alert color="warning">Unknown step # {step}!</Alert>
      </Container>
    )
  }

  const OurFallbackComponentTODO = ({ error, componentStack, resetErrorBoundary }) => {
    return (
      <div>
        <Container className="px-2 my-2" id="calcolaPaga1" tag="section">
          <Alert color="danger">Errore in Consultazione! {error.message}</Alert>
        </Container>
      </div>
    );
  };

  const getVariantForStep = (step) => {
    if (currentStep > step) return "confirmed";
    if (currentStep < step) return null;
    if (currentStep === step) return "active";
  }

  //START RENDERING
  return (
    <Container className="px-2 my-2" id="stepper-header" tag="section">
      <SibaBreadcrumb pageName={Constants.STR_CONSULTAZIONE_TITOLO} />
      <StepperContainer tag="div">
        <StepperHeader tag="ul">
          <>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_1}</>}
              variant={getVariantForStep(Constants.STEP_1)}
              noLine
            > <>{'Elenco veicoli'}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_2}</>}
              variant={getVariantForStep(Constants.STEP_2)}
              noLine
            > <>{currentStep >= 2 ? choiceDettagli : 'Dettagli'}</>
            </StepperHeaderElement>
            <StepperHeaderElement
              stepperNumber={<>{Constants.STEP_3}</>}
              variant={getVariantForStep(Constants.STEP_3)}
              noLine
            > <>{currentStep >= Constants.STEP_3 ? choicePagamento : 'Azioni'}</>
            </StepperHeaderElement>
          </>
        </StepperHeader>
      </StepperContainer>
      <Container className="px-2 my-2" id="stepper-content" tag="section">
        {getStepContent(currentStep)}
      </Container>
      <Container className="px-2 my-2" id="stepper-nav" tag="div">
        <Row>
          <Col>
            <div className="btn-toolbar justify-content-between" role="toolbar">
              <div className="btn-group mr-2">
                <Button
                  className="btn btn-outline-primary"
                  icon={false}
                  size="sm"
                  tag='a'
                  href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                  role='button'
                > {Constants.STR_BUTTON_RESET}
                </Button>
                {currentStep !== Constants.STEP_1 ? (
                  <Button
                    className="btn btn-outline-primary"
                    icon={false}
                    size="sm"
                    tag="button"
                    onClick={handleBack}
                  > {Constants.STR_BUTTON_INDIETRO}
                  </Button>
                ) : React.Fragment}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container >
  )
}

export default SibaConsultazioneVeicoliAttivi;